import React from 'react'
import { Link } from 'gatsby'
import clsx from 'clsx'

type FooterProps = {
  dark?: boolean
}

/*
NOTE: keep this in sync with legacy/docs/_includes/footer.html
*/
export const Footer: React.FC<FooterProps> = ({ dark = false }) => {
  return (
    <footer className={clsx('footer', dark ? 'footer-dark' : '')}>
      <div className='footer__container container'>
        <div className='footer__left'>
          {/*}
            <p>
              <Link to='/blog/2023/01/multimonth-and-more' style={{ color: 'inherit' }}>
                <span style={{ color: '#FAC863' }}>Jan 27</span> &mdash; Multi-Month &amp; more in
                v6.1
              </Link>
            </p>
          */}
          <p>
            <Link
              to='/blog/2021/02/10percent-profits-to-effective-charities'
              style={{ color: 'inherit' }}
            >
              <strong>10%</strong>
              {' of profits donated to '}
              <strong>effective charities</strong>
            </Link>
          </p>
          <p>
            <a
              href='https://docs.google.com/forms/d/e/1FAIpQLSf9mPTzy0tMSRN53y0CSnHLgS6uwlne2sK-tcwIbUZzs_LOUA/viewform?usp=sf_link'
              target='_blank'
              rel='noreferrer'
            >
              Does your company use FullCalendar? Tell us &raquo;
            </a>
          </p>
        </div>
        <nav className='footer__right'>
          <p>&copy; 2025&nbsp;&nbsp;FullCalendar LLC</p>
          <ul className='inline-list'>
            <li>
              <a href='https://github.com/fullcalendar' target='_blank' rel='noreferrer'>
                GitHub
              </a>
            </li>
            <li>
              <Link to='/license'>License</Link>
            </li>
            <li>
              <Link to='/blog'>Blog</Link>
            </li>
            <li>
              <Link to='/roadmap'>Roadmap</Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  )
}
